import baustein from "baustein";
import { openSignupOverlay } from "web/redux/ducks/signup-overlay";
import store from "web/redux/store";
import analytics from "web/script/analytics/analytics";
import { openEmailCaptureOverlay } from "web/redux/ducks/email-capture-overlay";

/**
 * This module 'saved-search-signup-prompt' displays the signup
 * overlay when clicking "save search" buttons if you are a logged out user.
 *
 * @constructor
 * @alias module:components/saved-search-signup-prompt
 * @extends module:baustein
 */
export default baustein.register("saved-search-signup-prompt", {
    defaultOptions: {
        searchQuery: null,
        searchGender: null,
        searchNext: null,
        pageType: "signup form",
        pageSubType: "saved_search",
        useEmailCapture: null,
    },

    setupEvents(add) {
        add("click", this.onClick);
    },

    onClick(event) {
        event.preventDefault();

        analytics.event("saved search", "clicked", this.options.searchQuery);
        if (this.options.useEmailCapture === true) {
            const options = {
                captureType: "signup_search",
                searchGender: this.options.searchGender,
                searchTerm: this.options.searchQuery,
                next: this.options.searchNext,
            };
            store.dispatch(openEmailCaptureOverlay(options));
        } else {
            const queryParams = {
                search_query: this.options.searchQuery,
                search_gender: this.options.searchGender,
                type: "saved_search",
                next: this.options.searchNext,
            };

            const options = {
                path: "/account/register/",
                queryParams: queryParams,
                formType: "saved_search",
                pageType: this.options.pageType,
                pageSubType: this.options.pageSubType,
            };

            store.dispatch(openSignupOverlay(options));
        }
    },
});
